import { isProductPage } from './config.js';

const hidePositionCompatibilityInformation = () => {
  [...window.document.querySelectorAll('.cm_verify-fitment_compatibility')].forEach((e) => e.remove());
};

const getPositionHtml = (isCompatible, message) => `
  <div class="${isCompatible ? 'cm_verify-fitment__yes' : 'cm_verify-fitment__no'}">
    <div class="cm_verify-fitment_title">
      <svg class="cm_icon cm_icon-${isCompatible ? 'check' : 'times'}" height="20px" role="img" viewBox="0 0 ${isCompatible ? '492 492' : '22 22'}">
        <path d="${
          isCompatible
            ? 'm484.13 104.48-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856s-13.964 2.788-19.028 7.856l-226.45 226.45-141.48-141.49c-5.064-5.06-11.82-7.852-19.028-7.852-7.204 0-13.956 2.792-19.024 7.852l-16.12 16.112c-5.068 5.076-7.852 11.836-7.852 19.036 0 7.204 2.784 13.96 7.852 19.028l159.74 159.74c0.212 0.3 0.436 0.58 0.696 0.836l16.12 15.852c5.064 5.048 11.82 7.572 19.084 7.572h0.084c7.212 0 13.968-2.524 19.024-7.572l16.124-15.992c0.26-0.256 0.48-0.468 0.612-0.684l244.78-244.76c10.5-10.476 10.5-27.52 4e-3-38.008z'
            : 'M1,1L21,21M21,1L1,21'
        }"/>
      </svg>
      ${message}
    </div>
  </div>
`;

const getNonStaggeredPositionHtml = (positions) => {
  const isFrontCompatible = positions.Front === 'Yes';
  const isRearCompatible = positions.Rear === 'Yes';
  const isBothCompatible = isFrontCompatible && isRearCompatible;
  const isBothNotCompatible = !isFrontCompatible && !isRearCompatible;

  const message =
    !isBothCompatible && !isBothNotCompatible
      ? `This option is not compatible with your selected vehicle in ${isFrontCompatible ? 'Rear' : 'Front'} position`
      : `This option is ${isBothNotCompatible ? 'not ' : ''}compatible with your selected vehicle`;

  return getPositionHtml(isBothCompatible, message);
};
const getStaggeredPositionHtml = (position, compatibility) => {
  const isCompatible = compatibility === 'Yes';
  const message = `This ${position} option is ${!isCompatible ? 'not ' : ''}compatible with your selected vehicle`;

  return getPositionHtml(isCompatible, message);
};

const updatePositionCompatibility = (isVehicleSelected, variation, container, skuContainer, isFront) => {
  const { value: variationId } = window.document.querySelector(variation);

  if (!variationId || !isVehicleSelected) {
    hidePositionCompatibilityInformation();
    return;
  }

  window.Convermax.verifyFitmentPositionAsync(variationId)
    .then(({ fits, positionCompatibility }) => {
      if (fits !== 'yes' && fits !== 'no') {
        hidePositionCompatibilityInformation();
        return;
      }

      let verify = window.document.querySelector(`${container} .cm_verify-fitment_compatibility`);
      const isVerifyCreated = !!verify;

      if (!isVerifyCreated) {
        verify = window.document.createElement('div');
        verify.classList.add('cm_vehicle-widget', 'cm_verify-fitment', 'cm_verify-fitment_compatibility');
      }

      if (!window.document.querySelector('#staggered-fitment-checkbox')?.checked) {
        verify.innerHTML = getNonStaggeredPositionHtml(positionCompatibility);
      } else {
        verify.innerHTML = getStaggeredPositionHtml(
          isFront ? 'Front' : 'Rear',
          isFront ? positionCompatibility.Front : positionCompatibility.Rear,
        );
      }

      if (!isVerifyCreated) {
        const skuElement = window.document.querySelector(skuContainer);
        skuElement.parentNode.insertBefore(verify, skuElement.nextSibling);
      }
    })
    .catch(() => {
      hidePositionCompatibilityInformation();
    });
};

const addPositionCompatibilityEvent = (select, variation, container, skuContainer, isFront) => {
  window.document.querySelector(select).addEventListener('change', () => {
    setTimeout(() => {
      updatePositionCompatibility(
        window.Convermax.isVehicleSelected(),
        variation,
        container,
        skuContainer,
        isFront,
      );
    }, 100);
  });
};

export const onVehicleSelected = () => {
  if (isProductPage) {
    hidePositionCompatibilityInformation();
    setTimeout(() => {
      updatePositionCompatibility(
        true,
        'input[name="sf_front_selected_variation"]',
        '#front-wheel-options',
        '#sf_front_meta',
        true,
      );
      updatePositionCompatibility(
        true,
        'input[name="sf_rear_selected_variation"]',
        '#rear-wheel-options',
        '#sf_rear_meta',
        false,
      );
    }, 400);
  }
};

export const onVehicleDiscarded = () => {
  if (isProductPage) {
    hidePositionCompatibilityInformation();
  }
};

export const AfterInit = () => {
  if (isProductPage) {
    addPositionCompatibilityEvent(
      '#front_pa_size-bolt-pattern-offset',
      'input[name="sf_front_selected_variation"]',
      '#front-wheel-options',
      '#sf_front_meta',
      true,
    );
    addPositionCompatibilityEvent(
      '#rear_pa_size-bolt-pattern-offset',
      'input[name="sf_rear_selected_variation"]',
      '#rear-wheel-options',
      '#sf_rear_meta',
      false,
    );

    window.document.querySelector('#staggered-fitment-checkbox')?.addEventListener('click', () => {
      hidePositionCompatibilityInformation();
    });
  }
};
